import { render } from "./ConsultaCierres.vue?vue&type=template&id=26b6b6e8"
import script from "./ConsultaCierres.vue?vue&type=script&lang=js"
export * from "./ConsultaCierres.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__